export const scatterData = [
  {
    outcome: "Negative",
    weight: "9",
  },
  {
    outcome: "Negative",
    weight: "9",
  },
  {
    outcome: "Negative",
    weight: "7.9",
  },
  {
    outcome: "Negative",
    weight: "8",
  },
  {
    outcome: "Negative",
    weight: "7",
  },
  {
    outcome: "Negative",
    weight: "7",
  },
  {
    outcome: "Negative",
    weight: "7",
  },
  {
    outcome: "Negative",
    weight: "7",
  },
  {
    outcome: "Negative",
    weight: "7",
  },
  {
    outcome: "Negative",
    weight: "7",
  },
  {
    outcome: "Negative",
    weight: "4",
  },
  {
    outcome: "Negative",
    weight: "4.1",
  },
  {
    outcome: "Negative",
    weight: "4",
  },
  {
    outcome: "Negative",
    weight: "4.1",
  },
  {
    outcome: "Negative",
    weight: "3.9",
  },
  {
    outcome: "Negative",
    weight: "4.2",
  },
  {
    outcome: "Negative",
    weight: "4",
  },
  {
    outcome: "Negative",
    weight: "12",
  },
  {
    outcome: "Negative",
    weight: "3",
  },
  {
    outcome: "Negative",
    weight: "3",
  },
  {
    outcome: "Negative",
    weight: "3",
  },
  {
    outcome: "Negative",
    weight: "3",
  },
  {
    outcome: "Negative",
    weight: "3",
  },
  {
    outcome: "Negative",
    weight: "3",
  },
  {
    outcome: "Negative",
    weight: "3",
  },
  {
    outcome: "Negative",
    weight: "0.4",
  },
  {
    outcome: "Positive",
    weight: "14.5",
  },
  {
    outcome: "Positive",
    weight: "11.6",
  },
  {
    outcome: "Positive",
    weight: "9",
  },
  {
    outcome: "Positive",
    weight: "8",
  },
  {
    outcome: "Positive",
    weight: "8",
  },
  {
    outcome: "Positive",
    weight: "8.2",
  },
  {
    outcome: "Positive",
    weight: "6",
  },
  {
    outcome: "Positive",
    weight: "6",
  },
];

export const f1_data = [
  { recall: 0.0, precision: 0.0, f1: 0.0 },
  { recall: 0.05, precision: 0.0, f1: 0.0 },
  { recall: 0.1, precision: 0.0, f1: 0.0 },
  { recall: 0.15, precision: 0.0, f1: 0.0 },
  { recall: 0.2, precision: 0.0, f1: 0.0 },
  { recall: 0.25, precision: 0.0, f1: 0.0 },
  { recall: 0.3, precision: 0.0, f1: 0.0 },
  { recall: 0.35, precision: 0.0, f1: 0.0 },
  { recall: 0.4, precision: 0.0, f1: 0.0 },
  { recall: 0.45, precision: 0.0, f1: 0.0 },
  { recall: 0.5, precision: 0.0, f1: 0.0 },
  { recall: 0.55, precision: 0.0, f1: 0.0 },
  { recall: 0.6, precision: 0.0, f1: 0.0 },
  { recall: 0.65, precision: 0.0, f1: 0.0 },
  { recall: 0.7, precision: 0.0, f1: 0.0 },
  { recall: 0.75, precision: 0.0, f1: 0.0 },
  { recall: 0.8, precision: 0.0, f1: 0.0 },
  { recall: 0.85, precision: 0.0, f1: 0.0 },
  { recall: 0.9, precision: 0.0, f1: 0.0 },
  { recall: 0.95, precision: 0.0, f1: 0.0 },
  { recall: 1.0, precision: 0.0, f1: 0.0 },
  { recall: 0.0, precision: 0.05, f1: 0.0 },
  { recall: 0.05, precision: 0.05, f1: 0.0499999995 },
  { recall: 0.1, precision: 0.05, f1: 0.0666666662 },
  { recall: 0.15, precision: 0.05, f1: 0.0749999996 },
  { recall: 0.2, precision: 0.05, f1: 0.0799999997 },
  { recall: 0.25, precision: 0.05, f1: 0.0833333331 },
  { recall: 0.3, precision: 0.05, f1: 0.0857142855 },
  { recall: 0.35, precision: 0.05, f1: 0.0874999998 },
  { recall: 0.4, precision: 0.05, f1: 0.0888888887 },
  { recall: 0.45, precision: 0.05, f1: 0.0899999998 },
  { recall: 0.5, precision: 0.05, f1: 0.0909090907 },
  { recall: 0.55, precision: 0.05, f1: 0.0916666665 },
  { recall: 0.6, precision: 0.05, f1: 0.0923076922 },
  { recall: 0.65, precision: 0.05, f1: 0.0928571427 },
  { recall: 0.7, precision: 0.05, f1: 0.0933333332 },
  { recall: 0.75, precision: 0.05, f1: 0.0937499999 },
  { recall: 0.8, precision: 0.05, f1: 0.0941176469 },
  { recall: 0.85, precision: 0.05, f1: 0.0944444443 },
  { recall: 0.9, precision: 0.05, f1: 0.094736842 },
  { recall: 0.95, precision: 0.05, f1: 0.0949999999 },
  { recall: 1.0, precision: 0.05, f1: 0.0952380951 },
  { recall: 0.0, precision: 0.1, f1: 0.0 },
  { recall: 0.05, precision: 0.1, f1: 0.0666666662 },
  { recall: 0.1, precision: 0.1, f1: 0.0999999995 },
  { recall: 0.15, precision: 0.1, f1: 0.1199999995 },
  { recall: 0.2, precision: 0.1, f1: 0.1333333329 },
  { recall: 0.25, precision: 0.1, f1: 0.1428571424 },
  { recall: 0.3, precision: 0.1, f1: 0.1499999996 },
  { recall: 0.35, precision: 0.1, f1: 0.1555555552 },
  { recall: 0.4, precision: 0.1, f1: 0.1599999997 },
  { recall: 0.45, precision: 0.1, f1: 0.1636363633 },
  { recall: 0.5, precision: 0.1, f1: 0.1666666664 },
  { recall: 0.55, precision: 0.1, f1: 0.169230769 },
  { recall: 0.6, precision: 0.1, f1: 0.1714285712 },
  { recall: 0.65, precision: 0.1, f1: 0.1733333331 },
  { recall: 0.7, precision: 0.1, f1: 0.1749999998 },
  { recall: 0.75, precision: 0.1, f1: 0.176470588 },
  { recall: 0.8, precision: 0.1, f1: 0.1777777776 },
  { recall: 0.85, precision: 0.1, f1: 0.1789473682 },
  { recall: 0.9, precision: 0.1, f1: 0.1799999998 },
  { recall: 0.95, precision: 0.1, f1: 0.1809523808 },
  { recall: 1.0, precision: 0.1, f1: 0.1818181817 },
  { recall: 0.0, precision: 0.15, f1: 0.0 },
  { recall: 0.05, precision: 0.15, f1: 0.0749999996 },
  { recall: 0.1, precision: 0.15, f1: 0.1199999995 },
  { recall: 0.15, precision: 0.15, f1: 0.1499999995 },
  { recall: 0.2, precision: 0.15, f1: 0.1714285709 },
  { recall: 0.25, precision: 0.15, f1: 0.1874999995 },
  { recall: 0.3, precision: 0.15, f1: 0.1999999996 },
  { recall: 0.35, precision: 0.15, f1: 0.2099999996 },
  { recall: 0.4, precision: 0.15, f1: 0.2181818178 },
  { recall: 0.45, precision: 0.15, f1: 0.2249999996 },
  { recall: 0.5, precision: 0.15, f1: 0.2307692304 },
  { recall: 0.55, precision: 0.15, f1: 0.2357142854 },
  { recall: 0.6, precision: 0.15, f1: 0.2399999997 },
  { recall: 0.65, precision: 0.15, f1: 0.2437499997 },
  { recall: 0.7, precision: 0.15, f1: 0.2470588232 },
  { recall: 0.75, precision: 0.15, f1: 0.2499999997 },
  { recall: 0.8, precision: 0.15, f1: 0.2526315787 },
  { recall: 0.85, precision: 0.15, f1: 0.2549999997 },
  { recall: 0.9, precision: 0.15, f1: 0.2571428569 },
  { recall: 0.95, precision: 0.15, f1: 0.2590909089 },
  { recall: 1.0, precision: 0.15, f1: 0.260869565 },
  { recall: 0.0, precision: 0.2, f1: 0.0 },
  { recall: 0.05, precision: 0.2, f1: 0.0799999997 },
  { recall: 0.1, precision: 0.2, f1: 0.1333333329 },
  { recall: 0.15, precision: 0.2, f1: 0.1714285709 },
  { recall: 0.2, precision: 0.2, f1: 0.1999999995 },
  { recall: 0.25, precision: 0.2, f1: 0.2222222217 },
  { recall: 0.3, precision: 0.2, f1: 0.2399999995 },
  { recall: 0.35, precision: 0.2, f1: 0.2545454541 },
  { recall: 0.4, precision: 0.2, f1: 0.2666666662 },
  { recall: 0.45, precision: 0.2, f1: 0.2769230765 },
  { recall: 0.5, precision: 0.2, f1: 0.2857142853 },
  { recall: 0.55, precision: 0.2, f1: 0.2933333329 },
  { recall: 0.6, precision: 0.2, f1: 0.2999999996 },
  { recall: 0.65, precision: 0.2, f1: 0.3058823526 },
  { recall: 0.7, precision: 0.2, f1: 0.3111111108 },
  { recall: 0.75, precision: 0.2, f1: 0.3157894734 },
  { recall: 0.8, precision: 0.2, f1: 0.3199999997 },
  { recall: 0.85, precision: 0.2, f1: 0.3238095235 },
  { recall: 0.9, precision: 0.2, f1: 0.327272727 },
  { recall: 0.95, precision: 0.2, f1: 0.3304347823 },
  { recall: 1.0, precision: 0.2, f1: 0.3333333331 },
  { recall: 0.0, precision: 0.25, f1: 0.0 },
  { recall: 0.05, precision: 0.25, f1: 0.0833333331 },
  { recall: 0.1, precision: 0.25, f1: 0.1428571424 },
  { recall: 0.15, precision: 0.25, f1: 0.1874999995 },
  { recall: 0.2, precision: 0.25, f1: 0.2222222217 },
  { recall: 0.25, precision: 0.25, f1: 0.2499999995 },
  { recall: 0.3, precision: 0.25, f1: 0.2727272722 },
  { recall: 0.35, precision: 0.25, f1: 0.2916666662 },
  { recall: 0.4, precision: 0.25, f1: 0.3076923072 },
  { recall: 0.45, precision: 0.25, f1: 0.321428571 },
  { recall: 0.5, precision: 0.25, f1: 0.3333333329 },
  { recall: 0.55, precision: 0.25, f1: 0.3437499996 },
  { recall: 0.6, precision: 0.25, f1: 0.3529411761 },
  { recall: 0.65, precision: 0.25, f1: 0.3611111107 },
  { recall: 0.7, precision: 0.25, f1: 0.3684210522 },
  { recall: 0.75, precision: 0.25, f1: 0.3749999996 },
  { recall: 0.8, precision: 0.25, f1: 0.3809523806 },
  { recall: 0.85, precision: 0.25, f1: 0.386363636 },
  { recall: 0.9, precision: 0.25, f1: 0.3913043475 },
  { recall: 0.95, precision: 0.25, f1: 0.395833333 },
  { recall: 1.0, precision: 0.25, f1: 0.3999999997 },
  { recall: 0.0, precision: 0.3, f1: 0.0 },
  { recall: 0.05, precision: 0.3, f1: 0.0857142855 },
  { recall: 0.1, precision: 0.3, f1: 0.1499999996 },
  { recall: 0.15, precision: 0.3, f1: 0.1999999996 },
  { recall: 0.2, precision: 0.3, f1: 0.2399999995 },
  { recall: 0.25, precision: 0.3, f1: 0.2727272722 },
  { recall: 0.3, precision: 0.3, f1: 0.2999999995 },
  { recall: 0.35, precision: 0.3, f1: 0.3230769226 },
  { recall: 0.4, precision: 0.3, f1: 0.3428571424 },
  { recall: 0.45, precision: 0.3, f1: 0.3599999995 },
  { recall: 0.5, precision: 0.3, f1: 0.3749999995 },
  { recall: 0.55, precision: 0.3, f1: 0.3882352937 },
  { recall: 0.6, precision: 0.3, f1: 0.3999999996 },
  { recall: 0.65, precision: 0.3, f1: 0.4105263154 },
  { recall: 0.7, precision: 0.3, f1: 0.4199999996 },
  { recall: 0.75, precision: 0.3, f1: 0.4285714282 },
  { recall: 0.8, precision: 0.3, f1: 0.436363636 },
  { recall: 0.85, precision: 0.3, f1: 0.4434782605 },
  { recall: 0.9, precision: 0.3, f1: 0.4499999996 },
  { recall: 0.95, precision: 0.3, f1: 0.4559999996 },
  { recall: 1.0, precision: 0.3, f1: 0.4615384612 },
  { recall: 0.0, precision: 0.35, f1: 0.0 },
  { recall: 0.05, precision: 0.35, f1: 0.0874999998 },
  { recall: 0.1, precision: 0.35, f1: 0.1555555552 },
  { recall: 0.15, precision: 0.35, f1: 0.2099999996 },
  { recall: 0.2, precision: 0.35, f1: 0.2545454541 },
  { recall: 0.25, precision: 0.35, f1: 0.2916666662 },
  { recall: 0.3, precision: 0.35, f1: 0.3230769226 },
  { recall: 0.35, precision: 0.35, f1: 0.3499999995 },
  { recall: 0.4, precision: 0.35, f1: 0.3733333328 },
  { recall: 0.45, precision: 0.35, f1: 0.3937499995 },
  { recall: 0.5, precision: 0.35, f1: 0.4117647054 },
  { recall: 0.55, precision: 0.35, f1: 0.4277777773 },
  { recall: 0.6, precision: 0.35, f1: 0.4421052627 },
  { recall: 0.65, precision: 0.35, f1: 0.4549999995 },
  { recall: 0.7, precision: 0.35, f1: 0.4666666662 },
  { recall: 0.75, precision: 0.35, f1: 0.4772727268 },
  { recall: 0.8, precision: 0.35, f1: 0.4869565213 },
  { recall: 0.85, precision: 0.35, f1: 0.4958333329 },
  { recall: 0.9, precision: 0.35, f1: 0.5039999996 },
  { recall: 0.95, precision: 0.35, f1: 0.5115384611 },
  { recall: 1.0, precision: 0.35, f1: 0.5185185181 },
  { recall: 0.0, precision: 0.4, f1: 0.0 },
  { recall: 0.05, precision: 0.4, f1: 0.0888888887 },
  { recall: 0.1, precision: 0.4, f1: 0.1599999997 },
  { recall: 0.15, precision: 0.4, f1: 0.2181818178 },
  { recall: 0.2, precision: 0.4, f1: 0.2666666662 },
  { recall: 0.25, precision: 0.4, f1: 0.3076923072 },
  { recall: 0.3, precision: 0.4, f1: 0.3428571424 },
  { recall: 0.35, precision: 0.4, f1: 0.3733333328 },
  { recall: 0.4, precision: 0.4, f1: 0.3999999995 },
  { recall: 0.45, precision: 0.4, f1: 0.4235294113 },
  { recall: 0.5, precision: 0.4, f1: 0.444444444 },
  { recall: 0.55, precision: 0.4, f1: 0.4631578942 },
  { recall: 0.6, precision: 0.4, f1: 0.4799999995 },
  { recall: 0.65, precision: 0.4, f1: 0.4952380948 },
  { recall: 0.7, precision: 0.4, f1: 0.5090909086 },
  { recall: 0.75, precision: 0.4, f1: 0.52173913 },
  { recall: 0.8, precision: 0.4, f1: 0.5333333329 },
  { recall: 0.85, precision: 0.4, f1: 0.5439999996 },
  { recall: 0.9, precision: 0.4, f1: 0.5538461534 },
  { recall: 0.95, precision: 0.4, f1: 0.5629629625 },
  { recall: 1.0, precision: 0.4, f1: 0.571428571 },
  { recall: 0.0, precision: 0.45, f1: 0.0 },
  { recall: 0.05, precision: 0.45, f1: 0.0899999998 },
  { recall: 0.1, precision: 0.45, f1: 0.1636363633 },
  { recall: 0.15, precision: 0.45, f1: 0.2249999996 },
  { recall: 0.2, precision: 0.45, f1: 0.2769230765 },
  { recall: 0.25, precision: 0.45, f1: 0.321428571 },
  { recall: 0.3, precision: 0.45, f1: 0.3599999995 },
  { recall: 0.35, precision: 0.45, f1: 0.3937499995 },
  { recall: 0.4, precision: 0.45, f1: 0.4235294113 },
  { recall: 0.45, precision: 0.45, f1: 0.4499999995 },
  { recall: 0.5, precision: 0.45, f1: 0.47368421 },
  { recall: 0.55, precision: 0.45, f1: 0.4949999995 },
  { recall: 0.6, precision: 0.45, f1: 0.5142857138 },
  { recall: 0.65, precision: 0.45, f1: 0.5318181813 },
  { recall: 0.7, precision: 0.45, f1: 0.5478260865 },
  { recall: 0.75, precision: 0.45, f1: 0.5624999995 },
  { recall: 0.8, precision: 0.45, f1: 0.5759999995 },
  { recall: 0.85, precision: 0.45, f1: 0.588461538 },
  { recall: 0.9, precision: 0.45, f1: 0.5999999996 },
  { recall: 0.95, precision: 0.45, f1: 0.6107142853 },
  { recall: 1.0, precision: 0.45, f1: 0.6206896547 },
  { recall: 0.0, precision: 0.5, f1: 0.0 },
  { recall: 0.05, precision: 0.5, f1: 0.0909090907 },
  { recall: 0.1, precision: 0.5, f1: 0.1666666664 },
  { recall: 0.15, precision: 0.5, f1: 0.2307692304 },
  { recall: 0.2, precision: 0.5, f1: 0.2857142853 },
  { recall: 0.25, precision: 0.5, f1: 0.3333333329 },
  { recall: 0.3, precision: 0.5, f1: 0.3749999995 },
  { recall: 0.35, precision: 0.5, f1: 0.4117647054 },
  { recall: 0.4, precision: 0.5, f1: 0.444444444 },
  { recall: 0.45, precision: 0.5, f1: 0.47368421 },
  { recall: 0.5, precision: 0.5, f1: 0.4999999995 },
  { recall: 0.55, precision: 0.5, f1: 0.5238095233 },
  { recall: 0.6, precision: 0.5, f1: 0.545454545 },
  { recall: 0.65, precision: 0.5, f1: 0.5652173908 },
  { recall: 0.7, precision: 0.5, f1: 0.5833333328 },
  { recall: 0.75, precision: 0.5, f1: 0.5999999995 },
  { recall: 0.8, precision: 0.5, f1: 0.6153846149 },
  { recall: 0.85, precision: 0.5, f1: 0.6296296292 },
  { recall: 0.9, precision: 0.5, f1: 0.6428571424 },
  { recall: 0.95, precision: 0.5, f1: 0.6551724133 },
  { recall: 1.0, precision: 0.5, f1: 0.6666666662 },
  { recall: 0.0, precision: 0.55, f1: 0.0 },
  { recall: 0.05, precision: 0.55, f1: 0.0916666665 },
  { recall: 0.1, precision: 0.55, f1: 0.169230769 },
  { recall: 0.15, precision: 0.55, f1: 0.2357142854 },
  { recall: 0.2, precision: 0.55, f1: 0.2933333329 },
  { recall: 0.25, precision: 0.55, f1: 0.3437499996 },
  { recall: 0.3, precision: 0.55, f1: 0.3882352937 },
  { recall: 0.35, precision: 0.55, f1: 0.4277777773 },
  { recall: 0.4, precision: 0.55, f1: 0.4631578942 },
  { recall: 0.45, precision: 0.55, f1: 0.4949999995 },
  { recall: 0.5, precision: 0.55, f1: 0.5238095233 },
  { recall: 0.55, precision: 0.55, f1: 0.5499999995 },
  { recall: 0.6, precision: 0.55, f1: 0.573913043 },
  { recall: 0.65, precision: 0.55, f1: 0.5958333328 },
  { recall: 0.7, precision: 0.55, f1: 0.6159999995 },
  { recall: 0.75, precision: 0.55, f1: 0.6346153841 },
  { recall: 0.8, precision: 0.55, f1: 0.6518518514 },
  { recall: 0.85, precision: 0.55, f1: 0.6678571424 },
  { recall: 0.9, precision: 0.55, f1: 0.6827586202 },
  { recall: 0.95, precision: 0.55, f1: 0.6966666662 },
  { recall: 1.0, precision: 0.55, f1: 0.7096774189 },
  { recall: 0.0, precision: 0.6, f1: 0.0 },
  { recall: 0.05, precision: 0.6, f1: 0.0923076922 },
  { recall: 0.1, precision: 0.6, f1: 0.1714285712 },
  { recall: 0.15, precision: 0.6, f1: 0.2399999997 },
  { recall: 0.2, precision: 0.6, f1: 0.2999999996 },
  { recall: 0.25, precision: 0.6, f1: 0.3529411761 },
  { recall: 0.3, precision: 0.6, f1: 0.3999999996 },
  { recall: 0.35, precision: 0.6, f1: 0.4421052627 },
  { recall: 0.4, precision: 0.6, f1: 0.4799999995 },
  { recall: 0.45, precision: 0.6, f1: 0.5142857138 },
  { recall: 0.5, precision: 0.6, f1: 0.545454545 },
  { recall: 0.55, precision: 0.6, f1: 0.573913043 },
  { recall: 0.6, precision: 0.6, f1: 0.5999999995 },
  { recall: 0.65, precision: 0.6, f1: 0.6239999995 },
  { recall: 0.7, precision: 0.6, f1: 0.6461538457 },
  { recall: 0.75, precision: 0.6, f1: 0.6666666662 },
  { recall: 0.8, precision: 0.6, f1: 0.6857142852 },
  { recall: 0.85, precision: 0.6, f1: 0.7034482754 },
  { recall: 0.9, precision: 0.6, f1: 0.7199999995 },
  { recall: 0.95, precision: 0.6, f1: 0.7354838705 },
  { recall: 1.0, precision: 0.6, f1: 0.7499999995 },
  { recall: 0.0, precision: 0.65, f1: 0.0 },
  { recall: 0.05, precision: 0.65, f1: 0.0928571427 },
  { recall: 0.1, precision: 0.65, f1: 0.1733333331 },
  { recall: 0.15, precision: 0.65, f1: 0.2437499997 },
  { recall: 0.2, precision: 0.65, f1: 0.3058823526 },
  { recall: 0.25, precision: 0.65, f1: 0.3611111107 },
  { recall: 0.3, precision: 0.65, f1: 0.4105263154 },
  { recall: 0.35, precision: 0.65, f1: 0.4549999995 },
  { recall: 0.4, precision: 0.65, f1: 0.4952380948 },
  { recall: 0.45, precision: 0.65, f1: 0.5318181813 },
  { recall: 0.5, precision: 0.65, f1: 0.5652173908 },
  { recall: 0.55, precision: 0.65, f1: 0.5958333328 },
  { recall: 0.6, precision: 0.65, f1: 0.6239999995 },
  { recall: 0.65, precision: 0.65, f1: 0.6499999995 },
  { recall: 0.7, precision: 0.65, f1: 0.6740740736 },
  { recall: 0.75, precision: 0.65, f1: 0.6964285709 },
  { recall: 0.8, precision: 0.65, f1: 0.7172413788 },
  { recall: 0.85, precision: 0.65, f1: 0.7366666662 },
  { recall: 0.9, precision: 0.65, f1: 0.7548387092 },
  { recall: 0.95, precision: 0.65, f1: 0.7718749995 },
  { recall: 1.0, precision: 0.65, f1: 0.7878787874 },
  { recall: 0.0, precision: 0.7, f1: 0.0 },
  { recall: 0.05, precision: 0.7, f1: 0.0933333332 },
  { recall: 0.1, precision: 0.7, f1: 0.1749999998 },
  { recall: 0.15, precision: 0.7, f1: 0.2470588232 },
  { recall: 0.2, precision: 0.7, f1: 0.3111111108 },
  { recall: 0.25, precision: 0.7, f1: 0.3684210522 },
  { recall: 0.3, precision: 0.7, f1: 0.4199999996 },
  { recall: 0.35, precision: 0.7, f1: 0.4666666662 },
  { recall: 0.4, precision: 0.7, f1: 0.5090909086 },
  { recall: 0.45, precision: 0.7, f1: 0.5478260865 },
  { recall: 0.5, precision: 0.7, f1: 0.5833333328 },
  { recall: 0.55, precision: 0.7, f1: 0.6159999995 },
  { recall: 0.6, precision: 0.7, f1: 0.6461538457 },
  { recall: 0.65, precision: 0.7, f1: 0.6740740736 },
  { recall: 0.7, precision: 0.7, f1: 0.6999999995 },
  { recall: 0.75, precision: 0.7, f1: 0.7241379305 },
  { recall: 0.8, precision: 0.7, f1: 0.7466666662 },
  { recall: 0.85, precision: 0.7, f1: 0.767741935 },
  { recall: 0.9, precision: 0.7, f1: 0.7874999995 },
  { recall: 0.95, precision: 0.7, f1: 0.8060606056 },
  { recall: 1.0, precision: 0.7, f1: 0.8235294113 },
  { recall: 0.0, precision: 0.75, f1: 0.0 },
  { recall: 0.05, precision: 0.75, f1: 0.0937499999 },
  { recall: 0.1, precision: 0.75, f1: 0.176470588 },
  { recall: 0.15, precision: 0.75, f1: 0.2499999997 },
  { recall: 0.2, precision: 0.75, f1: 0.3157894734 },
  { recall: 0.25, precision: 0.75, f1: 0.3749999996 },
  { recall: 0.3, precision: 0.75, f1: 0.4285714282 },
  { recall: 0.35, precision: 0.75, f1: 0.4772727268 },
  { recall: 0.4, precision: 0.75, f1: 0.52173913 },
  { recall: 0.45, precision: 0.75, f1: 0.5624999995 },
  { recall: 0.5, precision: 0.75, f1: 0.5999999995 },
  { recall: 0.55, precision: 0.75, f1: 0.6346153841 },
  { recall: 0.6, precision: 0.75, f1: 0.6666666662 },
  { recall: 0.65, precision: 0.75, f1: 0.6964285709 },
  { recall: 0.7, precision: 0.75, f1: 0.7241379305 },
  { recall: 0.75, precision: 0.75, f1: 0.7499999995 },
  { recall: 0.8, precision: 0.75, f1: 0.7741935479 },
  { recall: 0.85, precision: 0.75, f1: 0.7968749995 },
  { recall: 0.9, precision: 0.75, f1: 0.8181818177 },
  { recall: 0.95, precision: 0.75, f1: 0.8382352936 },
  { recall: 1.0, precision: 0.75, f1: 0.8571428567 },
  { recall: 0.0, precision: 0.8, f1: 0.0 },
  { recall: 0.05, precision: 0.8, f1: 0.0941176469 },
  { recall: 0.1, precision: 0.8, f1: 0.1777777776 },
  { recall: 0.15, precision: 0.8, f1: 0.2526315787 },
  { recall: 0.2, precision: 0.8, f1: 0.3199999997 },
  { recall: 0.25, precision: 0.8, f1: 0.3809523806 },
  { recall: 0.3, precision: 0.8, f1: 0.436363636 },
  { recall: 0.35, precision: 0.8, f1: 0.4869565213 },
  { recall: 0.4, precision: 0.8, f1: 0.5333333329 },
  { recall: 0.45, precision: 0.8, f1: 0.5759999995 },
  { recall: 0.5, precision: 0.8, f1: 0.6153846149 },
  { recall: 0.55, precision: 0.8, f1: 0.6518518514 },
  { recall: 0.6, precision: 0.8, f1: 0.6857142852 },
  { recall: 0.65, precision: 0.8, f1: 0.7172413788 },
  { recall: 0.7, precision: 0.8, f1: 0.7466666662 },
  { recall: 0.75, precision: 0.8, f1: 0.7741935479 },
  { recall: 0.8, precision: 0.8, f1: 0.7999999995 },
  { recall: 0.85, precision: 0.8, f1: 0.8242424237 },
  { recall: 0.9, precision: 0.8, f1: 0.847058823 },
  { recall: 0.95, precision: 0.8, f1: 0.8685714281 },
  { recall: 1.0, precision: 0.8, f1: 0.8888888884 },
  { recall: 0.0, precision: 0.85, f1: 0.0 },
  { recall: 0.05, precision: 0.85, f1: 0.0944444443 },
  { recall: 0.1, precision: 0.85, f1: 0.1789473682 },
  { recall: 0.15, precision: 0.85, f1: 0.2549999997 },
  { recall: 0.2, precision: 0.85, f1: 0.3238095235 },
  { recall: 0.25, precision: 0.85, f1: 0.386363636 },
  { recall: 0.3, precision: 0.85, f1: 0.4434782605 },
  { recall: 0.35, precision: 0.85, f1: 0.4958333329 },
  { recall: 0.4, precision: 0.85, f1: 0.5439999996 },
  { recall: 0.45, precision: 0.85, f1: 0.588461538 },
  { recall: 0.5, precision: 0.85, f1: 0.6296296292 },
  { recall: 0.55, precision: 0.85, f1: 0.6678571424 },
  { recall: 0.6, precision: 0.85, f1: 0.7034482754 },
  { recall: 0.65, precision: 0.85, f1: 0.7366666662 },
  { recall: 0.7, precision: 0.85, f1: 0.767741935 },
  { recall: 0.75, precision: 0.85, f1: 0.7968749995 },
  { recall: 0.8, precision: 0.85, f1: 0.8242424237 },
  { recall: 0.85, precision: 0.85, f1: 0.8499999995 },
  { recall: 0.9, precision: 0.85, f1: 0.8742857138 },
  { recall: 0.95, precision: 0.85, f1: 0.8972222217 },
  { recall: 1.0, precision: 0.85, f1: 0.9189189184 },
  { recall: 0.0, precision: 0.9, f1: 0.0 },
  { recall: 0.05, precision: 0.9, f1: 0.094736842 },
  { recall: 0.1, precision: 0.9, f1: 0.1799999998 },
  { recall: 0.15, precision: 0.9, f1: 0.2571428569 },
  { recall: 0.2, precision: 0.9, f1: 0.327272727 },
  { recall: 0.25, precision: 0.9, f1: 0.3913043475 },
  { recall: 0.3, precision: 0.9, f1: 0.4499999996 },
  { recall: 0.35, precision: 0.9, f1: 0.5039999996 },
  { recall: 0.4, precision: 0.9, f1: 0.5538461534 },
  { recall: 0.45, precision: 0.9, f1: 0.5999999996 },
  { recall: 0.5, precision: 0.9, f1: 0.6428571424 },
  { recall: 0.55, precision: 0.9, f1: 0.6827586202 },
  { recall: 0.6, precision: 0.9, f1: 0.7199999995 },
  { recall: 0.65, precision: 0.9, f1: 0.7548387092 },
  { recall: 0.7, precision: 0.9, f1: 0.7874999995 },
  { recall: 0.75, precision: 0.9, f1: 0.8181818177 },
  { recall: 0.8, precision: 0.9, f1: 0.847058823 },
  { recall: 0.85, precision: 0.9, f1: 0.8742857138 },
  { recall: 0.9, precision: 0.9, f1: 0.8999999995 },
  { recall: 0.95, precision: 0.9, f1: 0.9243243238 },
  { recall: 1.0, precision: 0.9, f1: 0.9473684206 },
  { recall: 0.0, precision: 0.95, f1: 0.0 },
  { recall: 0.05, precision: 0.95, f1: 0.0949999999 },
  { recall: 0.1, precision: 0.95, f1: 0.1809523808 },
  { recall: 0.15, precision: 0.95, f1: 0.2590909089 },
  { recall: 0.2, precision: 0.95, f1: 0.3304347823 },
  { recall: 0.25, precision: 0.95, f1: 0.395833333 },
  { recall: 0.3, precision: 0.95, f1: 0.4559999996 },
  { recall: 0.35, precision: 0.95, f1: 0.5115384611 },
  { recall: 0.4, precision: 0.95, f1: 0.5629629625 },
  { recall: 0.45, precision: 0.95, f1: 0.6107142853 },
  { recall: 0.5, precision: 0.95, f1: 0.6551724133 },
  { recall: 0.55, precision: 0.95, f1: 0.6966666662 },
  { recall: 0.6, precision: 0.95, f1: 0.7354838705 },
  { recall: 0.65, precision: 0.95, f1: 0.7718749995 },
  { recall: 0.7, precision: 0.95, f1: 0.8060606056 },
  { recall: 0.75, precision: 0.95, f1: 0.8382352936 },
  { recall: 0.8, precision: 0.95, f1: 0.8685714281 },
  { recall: 0.85, precision: 0.95, f1: 0.8972222217 },
  { recall: 0.9, precision: 0.95, f1: 0.9243243238 },
  { recall: 0.95, precision: 0.95, f1: 0.9499999995 },
  { recall: 1.0, precision: 0.95, f1: 0.9743589739 },
  { recall: 0.0, precision: 1.0, f1: 0.0 },
  { recall: 0.05, precision: 1.0, f1: 0.0952380951 },
  { recall: 0.1, precision: 1.0, f1: 0.1818181817 },
  { recall: 0.15, precision: 1.0, f1: 0.260869565 },
  { recall: 0.2, precision: 1.0, f1: 0.3333333331 },
  { recall: 0.25, precision: 1.0, f1: 0.3999999997 },
  { recall: 0.3, precision: 1.0, f1: 0.4615384612 },
  { recall: 0.35, precision: 1.0, f1: 0.5185185181 },
  { recall: 0.4, precision: 1.0, f1: 0.571428571 },
  { recall: 0.45, precision: 1.0, f1: 0.6206896547 },
  { recall: 0.5, precision: 1.0, f1: 0.6666666662 },
  { recall: 0.55, precision: 1.0, f1: 0.7096774189 },
  { recall: 0.6, precision: 1.0, f1: 0.7499999995 },
  { recall: 0.65, precision: 1.0, f1: 0.7878787874 },
  { recall: 0.7, precision: 1.0, f1: 0.8235294113 },
  { recall: 0.75, precision: 1.0, f1: 0.8571428567 },
  { recall: 0.8, precision: 1.0, f1: 0.8888888884 },
  { recall: 0.85, precision: 1.0, f1: 0.9189189184 },
  { recall: 0.9, precision: 1.0, f1: 0.9473684206 },
  { recall: 0.95, precision: 1.0, f1: 0.9743589739 },
  { recall: 1.0, precision: 1.0, f1: 0.9999999995 },
];

export const errorData = [
  {
    thresh: 0.1,
    accuracy: 0.2352941176,
    precision: 0.2352941176,
    recall: 1.0,
    f1_score: 0.3809523809,
  },
  {
    thresh: 0.3666666667,
    accuracy: 0.2352941176,
    precision: 0.2352941176,
    recall: 1.0,
    f1_score: 0.3809523809,
  },
  {
    thresh: 0.6333333333,
    accuracy: 0.2647058824,
    precision: 0.2424242424,
    recall: 1.0,
    f1_score: 0.3902439024,
  },
  {
    thresh: 0.9,
    accuracy: 0.2647058824,
    precision: 0.2424242424,
    recall: 1.0,
    f1_score: 0.3902439024,
  },
  {
    thresh: 1.1666666667,
    accuracy: 0.2647058824,
    precision: 0.2424242424,
    recall: 1.0,
    f1_score: 0.3902439024,
  },
  {
    thresh: 1.4333333333,
    accuracy: 0.2647058824,
    precision: 0.2424242424,
    recall: 1.0,
    f1_score: 0.3902439024,
  },
  {
    thresh: 1.7,
    accuracy: 0.2647058824,
    precision: 0.2424242424,
    recall: 1.0,
    f1_score: 0.3902439024,
  },
  {
    thresh: 1.9666666667,
    accuracy: 0.2647058824,
    precision: 0.2424242424,
    recall: 1.0,
    f1_score: 0.3902439024,
  },
  {
    thresh: 2.2333333333,
    accuracy: 0.2647058824,
    precision: 0.2424242424,
    recall: 1.0,
    f1_score: 0.3902439024,
  },
  {
    thresh: 2.5,
    accuracy: 0.2647058824,
    precision: 0.2424242424,
    recall: 1.0,
    f1_score: 0.3902439024,
  },
  {
    thresh: 2.7666666667,
    accuracy: 0.2647058824,
    precision: 0.2424242424,
    recall: 1.0,
    f1_score: 0.3902439024,
  },
  {
    thresh: 3.0333333333,
    accuracy: 0.4705882353,
    precision: 0.3076923077,
    recall: 1.0,
    f1_score: 0.4705882353,
  },
  {
    thresh: 3.3,
    accuracy: 0.4705882353,
    precision: 0.3076923077,
    recall: 1.0,
    f1_score: 0.4705882353,
  },
  {
    thresh: 3.5666666667,
    accuracy: 0.4705882353,
    precision: 0.3076923077,
    recall: 1.0,
    f1_score: 0.4705882353,
  },
  {
    thresh: 3.8333333333,
    accuracy: 0.4705882353,
    precision: 0.3076923077,
    recall: 1.0,
    f1_score: 0.4705882353,
  },
  {
    thresh: 4.1,
    accuracy: 0.5882352941,
    precision: 0.3636363636,
    recall: 1.0,
    f1_score: 0.5333333333,
  },
  {
    thresh: 4.3666666667,
    accuracy: 0.6764705882,
    precision: 0.4210526316,
    recall: 1.0,
    f1_score: 0.5925925926,
  },
  {
    thresh: 4.6333333333,
    accuracy: 0.6764705882,
    precision: 0.4210526316,
    recall: 1.0,
    f1_score: 0.5925925926,
  },
  {
    thresh: 4.9,
    accuracy: 0.6764705882,
    precision: 0.4210526316,
    recall: 1.0,
    f1_score: 0.5925925926,
  },
  {
    thresh: 5.1666666667,
    accuracy: 0.6764705882,
    precision: 0.4210526316,
    recall: 1.0,
    f1_score: 0.5925925926,
  },
  {
    thresh: 5.4333333333,
    accuracy: 0.6764705882,
    precision: 0.4210526316,
    recall: 1.0,
    f1_score: 0.5925925926,
  },
  {
    thresh: 5.7,
    accuracy: 0.6764705882,
    precision: 0.4210526316,
    recall: 1.0,
    f1_score: 0.5925925926,
  },
  {
    thresh: 5.9666666667,
    accuracy: 0.6764705882,
    precision: 0.4210526316,
    recall: 1.0,
    f1_score: 0.5925925926,
  },
  {
    thresh: 6.2333333333,
    accuracy: 0.6176470588,
    precision: 0.3529411765,
    recall: 0.75,
    f1_score: 0.48,
  },
  {
    thresh: 6.5,
    accuracy: 0.6176470588,
    precision: 0.3529411765,
    recall: 0.75,
    f1_score: 0.48,
  },
  {
    thresh: 6.7666666667,
    accuracy: 0.6176470588,
    precision: 0.3529411765,
    recall: 0.75,
    f1_score: 0.48,
  },
  {
    thresh: 7.0333333333,
    accuracy: 0.7941176471,
    precision: 0.5454545455,
    recall: 0.75,
    f1_score: 0.6315789474,
  },
  {
    thresh: 7.3,
    accuracy: 0.7941176471,
    precision: 0.5454545455,
    recall: 0.75,
    f1_score: 0.6315789474,
  },
  {
    thresh: 7.5666666667,
    accuracy: 0.7941176471,
    precision: 0.5454545455,
    recall: 0.75,
    f1_score: 0.6315789474,
  },
  {
    thresh: 7.8333333333,
    accuracy: 0.7941176471,
    precision: 0.5454545455,
    recall: 0.75,
    f1_score: 0.6315789474,
  },
  {
    thresh: 8.1,
    accuracy: 0.7941176471,
    precision: 0.5714285714,
    recall: 0.5,
    f1_score: 0.5333333333,
  },
  {
    thresh: 8.3666666667,
    accuracy: 0.7647058824,
    precision: 0.5,
    recall: 0.375,
    f1_score: 0.4285714286,
  },
  {
    thresh: 8.6333333333,
    accuracy: 0.7647058824,
    precision: 0.5,
    recall: 0.375,
    f1_score: 0.4285714286,
  },
  {
    thresh: 8.9,
    accuracy: 0.7647058824,
    precision: 0.5,
    recall: 0.375,
    f1_score: 0.4285714286,
  },
  {
    thresh: 9.1666666667,
    accuracy: 0.7941176471,
    precision: 0.6666666667,
    recall: 0.25,
    f1_score: 0.3636363636,
  },
  {
    thresh: 9.4333333333,
    accuracy: 0.7941176471,
    precision: 0.6666666667,
    recall: 0.25,
    f1_score: 0.3636363636,
  },
  {
    thresh: 9.7,
    accuracy: 0.7941176471,
    precision: 0.6666666667,
    recall: 0.25,
    f1_score: 0.3636363636,
  },
  {
    thresh: 9.9666666667,
    accuracy: 0.7941176471,
    precision: 0.6666666667,
    recall: 0.25,
    f1_score: 0.3636363636,
  },
  {
    thresh: 10.2333333333,
    accuracy: 0.7941176471,
    precision: 0.6666666667,
    recall: 0.25,
    f1_score: 0.3636363636,
  },
  {
    thresh: 10.5,
    accuracy: 0.7941176471,
    precision: 0.6666666667,
    recall: 0.25,
    f1_score: 0.3636363636,
  },
  {
    thresh: 10.7666666667,
    accuracy: 0.7941176471,
    precision: 0.6666666667,
    recall: 0.25,
    f1_score: 0.3636363636,
  },
  {
    thresh: 11.0333333333,
    accuracy: 0.7941176471,
    precision: 0.6666666667,
    recall: 0.25,
    f1_score: 0.3636363636,
  },
  {
    thresh: 11.3,
    accuracy: 0.7941176471,
    precision: 0.6666666667,
    recall: 0.25,
    f1_score: 0.3636363636,
  },
  {
    thresh: 11.5666666667,
    accuracy: 0.7941176471,
    precision: 0.6666666667,
    recall: 0.25,
    f1_score: 0.3636363636,
  },
  {
    thresh: 11.8333333333,
    accuracy: 0.7647058824,
    precision: 0.5,
    recall: 0.125,
    f1_score: 0.2,
  },
  {
    thresh: 12.1,
    accuracy: 0.7941176471,
    precision: 1.0,
    recall: 0.125,
    f1_score: 0.2222222222,
  },
  {
    thresh: 12.3666666667,
    accuracy: 0.7941176471,
    precision: 1.0,
    recall: 0.125,
    f1_score: 0.2222222222,
  },
  {
    thresh: 12.6333333333,
    accuracy: 0.7941176471,
    precision: 1.0,
    recall: 0.125,
    f1_score: 0.2222222222,
  },
  {
    thresh: 12.9,
    accuracy: 0.7941176471,
    precision: 1.0,
    recall: 0.125,
    f1_score: 0.2222222222,
  },
  {
    thresh: 13.1666666667,
    accuracy: 0.7941176471,
    precision: 1.0,
    recall: 0.125,
    f1_score: 0.2222222222,
  },
  {
    thresh: 13.4333333333,
    accuracy: 0.7941176471,
    precision: 1.0,
    recall: 0.125,
    f1_score: 0.2222222222,
  },
  {
    thresh: 13.7,
    accuracy: 0.7941176471,
    precision: 1.0,
    recall: 0.125,
    f1_score: 0.2222222222,
  },
  {
    thresh: 13.9666666667,
    accuracy: 0.7941176471,
    precision: 1.0,
    recall: 0.125,
    f1_score: 0.2222222222,
  },
  {
    thresh: 14.2333333333,
    accuracy: 0.7941176471,
    precision: 1.0,
    recall: 0.125,
    f1_score: 0.2222222222,
  },
  {
    thresh: 14.5,
    accuracy: 0.7941176471,
    precision: 1.0,
    recall: 0.125,
    f1_score: 0.2222222222,
  },
];
